import { isKeyframesTarget as o } from "./atoms-v21078.js";
const r = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), a = (e) => o(e) ? e[e.length - 1] || 0 : e;
export {
  r as isCustomValue,
  a as resolveFinalValueInKeyframes
};
